import './styles/main.css';
import Body from './Body.js';
import Header from './Header';
function App() {
  return (
    <>
    <div class= "h-full min-h-screen bg-green-100">
      <Header/>
      <Body/>
    </div>
    </>
  );
}

export default App;
